import React from "react";

export const VersusBadge = ({ small = false }) => (
  <div
    data-testid="versus-badge"
    className={`vs-pulse relative flex items-center justify-center rounded-full bg-[#FF107A] text-[#FDFBF7] border-2 border-[#FDFBF7] font-display tracking-widest glow-pink ${
      small ? "w-12 h-12 text-xl" : "w-16 h-16 sm:w-20 sm:h-20 text-2xl sm:text-3xl"
    }`}
    style={{ transform: "rotate(-6deg)" }}
  >
    VS
  </div>
);
